import React, { useEffect, useState } from 'react';
import { ReactComponent as DollarIcon } from '../../assets/icons/dollar.svg';
import {
  Button,
  ButtonContainer,
  NumberInput,
  StyledButton,
  TooltipContainer,
} from './ChangeManualChatSpentThreshold.styles';
import { Text16Bold } from '../utils/Text/Text.styles';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedInfluencer } from '../../store/slices/chatter/slice';
import { editManualChatTotalSpentThreshold } from '../../store/slices/user/asyncThunks';
import { notifyError, notifyInfo } from '../../utils/notify';

const uploadCreateAssetFolderFormSchema = yup.object({
  manualChatTotalSpentThreshold: yup
    .number()
    .transform((value, originalValue) => {
      if (originalValue === '' || originalValue === null || Number.isNaN(value)) {
        return undefined;
      }
      return value;
    })
    .min(0, 'Amount must be positive or 0')
    .required('Amount is required'),
});

const ChangeManualChatSpentThreshold = () => {
  const influencer = useSelector(selectSelectedInfluencer);
  const dispatch = useDispatch();
  const [showTooltip, setShowTooltip] = useState(false);

  const {
    handleSubmit,
    formState: { errors },
    register,
    setValue,
  } = useForm({
    delayError: 300,
    defaultValues: {
      manualChatTotalSpentThreshold: '',
    },
    resolver: yupResolver(uploadCreateAssetFolderFormSchema),
  });

  useEffect(() => {
    if (influencer?.manualChatTotalSpentThreshold) {
      setValue('manualChatTotalSpentThreshold', influencer?.manualChatTotalSpentThreshold);
    }
  }, [influencer?.manualChatTotalSpentThreshold, setValue]);

  const onSubmit = data => {
    const { manualChatTotalSpentThreshold } = data;
    dispatch(editManualChatTotalSpentThreshold({ manualChatTotalSpentThreshold, influencerId: influencer.id }))
      .unwrap()
      .then(() => {
        notifyInfo('Spent threshold edited successfully!');
      })
      .catch(err => {
        notifyError(err.message);
      });
  };

  return (
    <ButtonContainer>
      <Button onMouseEnter={() => setShowTooltip(true)} onMouseLeave={() => setShowTooltip(false)}>
        <DollarIcon color="#fff" />
      </Button>
      {showTooltip && (
        <TooltipContainer
          onSubmit={handleSubmit(onSubmit)}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}>
          <Text16Bold>Spent</Text16Bold>
          <NumberInput
            label="At least"
            {...register('manualChatTotalSpentThreshold')}
            error={errors?.manualChatTotalSpentThreshold?.message}
            prefix="$"
          />
          <StyledButton>Save</StyledButton>
        </TooltipContainer>
      )}
    </ButtonContainer>
  );
};

export default ChangeManualChatSpentThreshold;
